import type { StageKind } from "@/adapters/api";

export const STAGE_KINDS: StageKind[] = ["stage", "substage", "service"];

export const STAGE_KIND: Record<StageKind, { label: string; noun: string }> = {
	stage: { label: "Etapa", noun: "etapa" },
	substage: { label: "Subetapa", noun: "subetapa" },
	service: { label: "Serviço", noun: "serviço" },
};

export function isStageKind(
	value: string | null | undefined,
): value is StageKind {
	return STAGE_KINDS.includes(value as StageKind);
}

export function defaultKind(parentId: string | undefined): StageKind {
	return parentId ? "substage" : "stage";
}
